import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {CuentasBancariasService, PageBusquedaObject, Banco, Cuenta, CtaBancaria} from '../cuentas-bancarias.service';
import Swal from 'sweetalert2';
import {GralMon} from '../../../entity/GralMon';
import { LoginService } from '../../../login/login.service';

@Component({
  selector: 'app-formulario-cuentas-bancarias',
  templateUrl: './formulario-cuentas-bancarias.component.html',
  styleUrls: ['./formulario-cuentas-bancarias.component.css']
})
export class FormularioCuentasBancariasComponent implements OnInit {

  public id_param: number;
  errors: String[];
  monedas: GralMon[];
  bn: Banco[];
  busquedaCuentas: PageBusquedaObject = new PageBusquedaObject();
  cuent: Cuenta[];
  public dto: CtaBancaria = new CtaBancaria();
  busqueda: PageBusquedaObject = new PageBusquedaObject();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public loginService: LoginService,
    private service: CuentasBancariasService
  ) { }

  ngOnInit() {
    // this.moneda();
    this.dto.banco = new Banco();
    this.dto.cuent = new Cuenta();
    this.dto.gralMon = new GralMon();
    this.busquedaCuentas.criteriaSearch = {};
    this.busquedaCuentas.itemsPerPage = 5;
    this.busquedaCuentas.pageNumber = 0;
    this.busqueda.criteriaSearch = {};
    this.activatedRoute.params.subscribe(params => {
      this.id_param = params['id'];
      if (this.id_param) {
        this.service.getCuenta(this.id_param).subscribe(response => {
          console.log('response', response);
          this.dto = response.contenido;
          console.log('this.dto', this.dto);
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          })
          console.log(err);
        });
      }
    });
  }
  ValidaSoloNumeros() {
    var e = e || window.event;
    if ((e.keyCode < 46) || (e.keyCode > 57)) {
      e.returnValue = false;
      e.preventDefault();
    }
  }
  crear() {
    this.dto.gralUsrCreaId = this.loginService.usuario.id;
    console.log(this.dto);
    this.service.post(this.dto).subscribe(response => {
      Swal.fire('TNK Ledger', response.mensaje, 'success');
      this.router.navigate(['/contabilidad/catalogo/cta-bancaria']);
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }

  actualizar() {
    this.dto.gralUsrActualizaId = this.loginService.usuario.id as number;
    this.service.put(this.dto).subscribe(response => {
      Swal.fire('TNK Ledger', response.mensaje, 'success');
      this.router.navigate(['/contabilidad/catalogo/cta-bancaria']);
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }

  getBancos() {
    this.service.getBancos(this.dto.banco.titulo).subscribe(response => {
      this.bn = response;
      if (this.bn != null && this.bn.length == 1 && this.dto.banco.titulo == this.bn[0].titulo) {
        this.dto.banco = this.bn[0];
      }
    });
  }

  getCuentas() {
    this.busquedaCuentas.criteriaSearch['cuenta'] = this.dto.cuent.cuenta;
  this.busquedaCuentas.criteriaSearch['emp'] = this.loginService.empresa;
    this.service.getCuentas(this.busquedaCuentas).subscribe(response => {
      this.cuent = response.contenido.content;

      if (this.cuent != null && this.cuent.length === 1 && this.cuent[0].cuenta === this.dto.cuent.cuenta) {
        this.dto.cuent = this.cuent[0];
      }
    });
  }

  getMonedas() {
    this.service.getMonedas(this.dto.gralMon.claveS).subscribe(response => {
      this.monedas = response;

      if (this.monedas != null && this.monedas.length === 1 && this.dto.gralMon.claveS === this.monedas[0].claveS) {
        this.dto.gralMon = this.monedas[0];
      }
    });
  }

  compare(m1: GralMon, m2: GralMon) {
    return m1 && m2 ? m1.claveS === m2.claveS : m1 === m2;
  }

}
